import React, { useState } from "react";
import { Modal, message, Button, Input } from "antd";

import BoxServe from "../../../ajax/api/index";
const { TextArea } = Input;
export default function UpdateBoxInfoModel(props) {
  const [loading, setLoading] = useState(false);

  const [tagList, setTagList] = useState("");

  // 关闭弹框
  const onCancel = () => {
    setTagList("");
    props.handleupdateBoxInfoModelClose(false);
  };

  const onChange = (e) => {
    setTagList(e.target.value || "");
  };

  // 提交
  const handleSubmit = async () => {
    const deviceNoList = props.list?.join(",") || "";

    const params = {
      deviceNoList,
      tagList,
    };
    try {
      setLoading(true);
      const { code, msg } = await BoxServe.updateBoxInfo(params).finally(() => {
        setLoading(false);
      });
      if (String(code) === "0") {
        setTagList("");
        message.success(msg);
        setTimeout(() => {
          onCancel();
          props.getBusinessList("business"); // 列表需要重置选中
        }, 200);
      } else {
        message.error("错误！");
      }
    } catch (error) {
      setLoading(false);
      message.error(error.message || error.msg);
      console.log(error);
    }
  };
  return (
    <>
      <div className="business-switching pressure-measurement">
        <Modal
          title="压测"
          width="1000px"
          className="pressure-model business-model"
          footer={null}
          open={props.open}
          onCancel={onCancel}
        >
          <div className="box">
            <span className="title">已选盒子编号</span>
            <div className="list ">
              {props.list?.map((item, index) => (
                <span key={index} className="list-item">
                  {item}
                </span>
              ))}
              <span className="list-item">等{props?.list?.length}个盒子</span>
            </div>
          </div>
          <div className="box">
            <span className="title">设备标记</span>
            <div className="list ">
              <TextArea
                rows={4}
                value={tagList}
                showCount
                placeholder="请输入设备标记，多个用英文逗号隔开"
                maxLength={120}
                onChange={onChange}
              />
            </div>
          </div>

          <Button
            type="primary"
            className="box-btn"
            loading={loading}
            shape="round"
            size={"large"}
            onClick={handleSubmit}
          >
            确 定
          </Button>
        </Modal>
      </div>
    </>
  );
}
